<template>
    <!-- :close-on-click-modal="true"为false的时候点击模态框之外的地方不会执行:before-close="handleCloseAll"操作 -->
    <el-dialog
        title="网址导航"
        :visible.sync="visible1"
        :before-close="handleCloseAll"
        class="dialog manage-common-sites"
        :close-on-click-modal="true"
        width="64%"
        @open="acquireSites"
        custom-class="minH">
        <!-- <el-divider content-position="left"></el-divider> -->
        <el-divider></el-divider>
        <!-- v-if="revealing"进行判定当前状态为编辑状态还是展示状态 -->
        <div v-loading="isLoading" class="site-container" style="display: flex; flex-wrap: wrap;" v-if="revealing">
            <ul class="more-dialog">
                <li v-for="site in sites" :key="site.id" style="position: relative">
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" content="添加到常用网址" :enterable="false">
                        <el-button type="text" size="mini" @click="addToCommon(site)"><img src="../assets/plus.png" width="18px"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" :enterable="false">
                        <div slot="content" style="max-width:300px;line-height: 20px;">
                            {{site.name}}
                            {{site.desc}}
                        </div>
                        <a :href="site.url" target="_blank" rel="nofollow" style="position: absolute; top: 2px; padding-left: 4px;">{{site.name}}</a>
                    </el-tooltip>
                </li>
            </ul>
        </div>
        <!-- 禁止拖拽:disabled=""。true为不可拖拽，false则反之 -->
        <draggable :disabled="true" v-model="sites" class="site-container" v-if="!revealing">
            <div
                class="site-item"
                v-for="site in sites"
                :key="site.id">
                <el-tag
                    closable
                    @click="handleClickSite(site)"
                    @close="deleteCustom(site)">
                    <span>{{site.name}}</span>
                </el-tag>
            </div>
        </draggable>
        <div style="padding-top:15px"></div>
        <el-divider content-position="left" v-if="!revealing">编辑网址</el-divider>
        <el-form :inline="true" :rules="rules" :model="editSite" ref="editSite" class="demo-form-inline" v-if="!revealing">
            <el-form-item label="名称" prop="name">
                <el-input autosize v-model="editSite.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="网址" prop="url">
                <el-input autosize v-model="editSite.url" placeholder="网址"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="desc">
                <el-input autosize v-model="editSite.desc" placeholder="输入描述"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onEditSite">{{editButton}}</el-button>
            </el-form-item>
        </el-form>
<!--        <el-divider content-position="left">推荐网址</el-divider>-->
<!--        <span></span>-->
        <span slot="footer" class="dialog-footer" v-if="!revealing">
            <el-button @click="redact(1)">完 成</el-button>
            <!-- <el-button type="primary" @click="handleSave">保 存</el-button> -->
        </span>
        <div class="editor">
            <span class="mRight" @click="redact(0)">编辑</span>
            <el-select @change="toggle" v-model="value" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>
    </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import '../utils/idServer'
import request from "../utils/request";
import {eventBus} from "../main";

/**
 * default data: sites, sort, type
 * custom: changed sort, added(to total list and common), removed(from common)
 *          name change, url change
 * 前端从后端获取默认网址列表，本地存自定义数据存储自定义网址表
 * 自定义网址封装为完整site对象，先遍历默认网址列表，遍历自定义列表（修改、添加，删除 判断标志位）
 *
 * 此组件为通用的网址列表编辑组件，给管理常用网址列表和分类下的网址列表共同使用
 */

export default {
    components: {
        draggable
    },
    props: {
        // 判定页面的显隐性
        visible: Boolean,
        // 当前二级的数据
        manageType:Object,
        defaultSites: Array | Function,
        customSites: Array
    },
    data() {
        return {
            editSite: {id: 0, name: '', url: '',desc:''},
            rules: {
                // name: [
                //     { required: true, message: '请输入网站名称', trigger: 'blur' },
                //     { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
                // ],
                // url: [
                //     { required: true, message: '请输入网址', trigger: 'blur' },
                //     { pattern: /\w+\.\w+/, message: '请输入正确的网址', trigger: 'blur' }
                // ]
            },
            // 网址数据
            sites: [],
            // 下拉菜单数据
            options: [],
            value: '',
            //保存三级下拉菜单点击的name
            tag:'',
            // 控制编辑的显隐性
            revealing:true,
            editButton:'添加',
            visible1:false,
            isLoading: true,
        }
    },
    created(){
    },

    watch:{
        visible(){
            this.visible1=this.visible
        }
    },
    methods: {
        // 点击二级菜单进入三级时触发，获取当前二级下默认的第一个三级菜单内的数据
        acquireSites(tag){
            this.isLoading=true
            var url = "/api/nav/typeSite?type=" + this.manageType.id;
            if (tag !=undefined) {
                url=url+"&tag="+tag;
            }
            request({
                url: url,
                method: "post",
                data:{"token" : localStorage.getItem("token")}
            }).then((r) => {
                this.isLoading=false
                this.sites=r.list;
                if (tag ==undefined) {
                    this.tag=r.three[0]
                } else {
                    this.tag=tag
                }

                this.options=[];
                for (let i = 0; i < r.three.length; i++) {
                    let arr={}
                    arr.value=r.three[i]
                    this.options.push(arr)
                }
                // 使下拉菜单初始化数据为菜单的第一个
                if(this.value==''){
                    this.value=this.options[0].value
                }
            }).catch(error => {
                console.log(error);
            });
        },
        // 修改/添加时触发
        onEditSite() {
            let userSite1={
                name:this.editSite.name,
                url:this.editSite.url,
                description:this.editSite.desc,
                tag:this.tag,
                type:this.manageType.id
            }
            let url=''
            if (this.editButton=='修改') {
                userSite1.siteId=this.editSite.id
                url='/api/nav/editCustom'
            } else {
                url="/api/nav/custom"
            }

            request({
                url: url,
                method: "post",
                data: {"token" : localStorage.getItem("token"),userSite:userSite1}
            }).then((r) => {
                this.editSite={id: 0, name: '', url: '',desc:''},
                this.editButton="添加"
                this.acquireSites(this.tag)
            }).catch(error => {
                console.log(error);
            });
        },
        append(test){
            // console.log(test);
        },
        // 保存时触发
        handleSave() {
            let saveMap = {}
            let originMap = {}
            for(const key in this.sites) {
                const site = this.sites[key]
                saveMap[site.id] = site
            }

            for (let i = 0; i < this.defaultSites.length; i++) {
                const ds = this.defaultSites[i];
                originMap[ds.id] = ds
            }

            let customs = []
            let shouldSort = false
            let lastSort = 0
            for (let i = 0; i < this.sites.length; i++) {
                const site = this.sites[i];
                let origin = originMap[site.id]

                if(!shouldSort && (site.sort == undefined || site.sort <= lastSort)) {
                    site.sort = lastSort + 1
                    shouldSort = true
                }
                lastSort = site.sort

                //修改记录
                if(origin != null) {
                    //内容修改
                    if(origin.name != site.name || origin.url != site.url || origin.tag != site.tag) {
                        // console.log('modification', site)
                        customs.push(site)
                        continue
                    }

                    //排序修改
                    if(shouldSort) {
                        // console.log('sort', site)
                        customs.push({
                            id: site.id,
                            forSort: true
                        })
                    }

                    continue
                }

                //新增记录
                // console.log('insertion', site)
                customs.push(site)
            }

            for (let i = 0; i < this.defaultSites.length; i++) {
                const origin = this.defaultSites[i];
                if(saveMap[origin.id] == null) {
                    //删除记录
                    // console.log('deletion', origin)
                    customs.push({
                        id: origin.id,
                        delete: true
                    })
                }
            }

            this.$emit('save', customs)
            this.handleClose()
        },
        // resetEditForm() {
        //     this.editSite = {
        //         id: 0,
        //         name: '',
        //         url: ''
        //     }
        //     this.editButton = '添加'
        // },
        // 返回时触发
        // handleClose() {
        //     this.resetEditForm()
        //     this.$emit('close')
        // },
        // 页面右上角×的时候触发
        handleCloseAll(done) {
            this.sites=[]
            this.value=''
            this.revealing =true
            // this.handleClose()
            this.$emit('close')
            this.$emit('close-all')
            done()
        },
        //子元素×的时候触发
        handleRemove(site) {
            // this.sites = this.sites.filter(function(item) {
            //     return item != site
            // })
            // this.resetEditForm()
        },
        // 点击触发事件
        handleClickSite(site) {
            this.editSite = {
                id: site.id,
                name: site.name,
                url: site.url,
                tag: site.tag,
            }
            this.editButton = '修改'
        },
        // 菜单切换时触发
        toggle(e){
            this.acquireSites(e)
        },
        // 点击×，完成，编辑时触发
        redact(num){
            if(this.global.account == null) {
                this.$message({
                    message: '请先登录',
                    type: 'warning'
                });
                // this.$router.replace('/')
                eventBus.$emit('show-login', '');
                return;
            }else{
                if (num ==0) {
                    this.revealing =false
                }else{
                    this.revealing =true
                }
            }


        },
        // 点击＋号收藏时进行触发
        addToCommon(site){
            if(this.global.account == null) {
                this.$message({
                    message: '请先登录',
                    type: 'warning' //黄色弹窗
                });
                // this.$router.replace('/')
                eventBus.$emit('show-login', '');
                return;
            }else{
                let userSite1={
                    name:site.name,
                    url:site.url,
                    description:site.desc,
                }
                request({
                    url: "/api/nav/collect",
                    method: "post",
                    data: {"token" : localStorage.getItem("token"),siteCollect:userSite1}
                }).then((r) => {
                    // 提示框
                    if (r == '请勿重复收藏') {
                        this.$message({
                            message: r,
                            type: 'warning' //黄色弹窗
                        });
                    }else{
                        this.$message({
                            message: '收藏成功',
                            type: 'success' //绿色弹窗
                        });
                    }


                }).catch(error => {
                    console.log(error);
                });
            }
        },
        // 编辑删除时触发
        deleteCustom(site){
            // key:userSite
            let userSite1={
                name:site.name,
                url:site.url,
                type:this.manageType.id
            }
            request({
                url: "/api/nav/deleteCustom ",
                method: "post",
                data: {"token" : localStorage.getItem("token"),userSite:userSite1}
            }).then((r) => {
                this.acquireSites(this.tag)
            }).catch(error => {
                console.log(error);
            });
        }
    }
}
</script>

<style>
.minH{
    min-height: 110px;
}
.minH .el-loading-spinner{
    margin-top: 5px;
}
.manage-common-sites .el-tag {
    height: 20px;
    line-height: 20px;
}

.manage-common-sites .el-dialog__body {
    padding: 0 20px;
}
</style>

<style scoped>
/* .site-container {
    display: flex;
} */
.site-item {
    padding: 4px;
    height: 28px;
    display: inline;
    align-items: center;
    width: 16.66666667%;
}

.site-item > span {
    cursor: pointer;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    white-space: nowrap;
}

.dialog > .el-dialog__body {
    padding:0px;
}
.dialog .el-divider--horizontal{
    margin: 10px 0 15px 0;
}
.editor{
    display: flex;
    position: absolute;
    right: 60px;
    top: 12px;
}
.mRight{
    margin-right: 10px;
    border-radius: 4px;
    height: 38px;
    border: 1px solid #DCDFE6;
    display: block;
    line-height: 40px;
    padding: 0 5px;
    width: 60px;
    text-align: center;
}
.more-dialog {
	line-height: 32px;
    margin-left: 30px;
}
.more-dialog li {
	display: inline-block;
    padding: 0 10px;
    width: 135px;
    white-space: nowrap;
}
.more-dialog li a {
	width: 120px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageCommon.vue